module.exports = __webpack_public_path__ + "assets/img/qianzhang.e602dc5a.png";